import { createContext, useContext } from 'react';
import DynamicTextDTO from '../../interfaces/dto/dynamicTextDTO';

interface DefaultValueProps {
  dynamicText: DynamicTextDTO | undefined;
}

const defaultValue: DefaultValueProps = { dynamicText: undefined };

export const DynamicTextContext = createContext(defaultValue);

export const useDynamicTextContext = () => {
  const context = useContext(DynamicTextContext);
  if (!context) {
    throw new Error('You must use the DynamicText Provider in order to consume this context.');
  }
  return context;
};
